// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ProductsError_errorText__2OzaY"};